import { useRef, useState, useEffect } from 'react'

// Services
import { addData } from '../index'
import { subscribeCounterData } from '../normal'
import { subscribeFeedbackData } from '../feedback'

// Utils
import isEmpty from 'lodash/isEmpty'

//  Constants
import { COLLECTION_NAME } from '../../../../constants/Constants'

// eslint-disable-next-line no-unused-vars
export const useFeedbackData = props => {
  // State
  const [feedbackDataList, setFeedbackDataList] = useState([])
  const [feedbackCounterData, setFeedbackCounterData] = useState([])

  //  Ref
  const unsubscribeFeedbackDataListRef = useRef()
  const unsubscribeFeedbackCounterDataRef = useRef(null)

  //
  useEffect(() => {
    return () => {
      // Cleanup here
      clearAllSubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getCurrentData(type, sortBy, sortValue, sortType, previous, currentPage, limit, callback) {
    //
    if (unsubscribeFeedbackDataListRef.current) {
      unsubscribeFeedbackDataListRef.current && unsubscribeFeedbackDataListRef.current()
    }

    const unsubscribe = await subscribeFeedbackData(
      type,
      sortBy,
      sortValue,
      sortType,
      previous,
      currentPage,
      limit,
      feedbackDataList,
      (feedbackData, error) => {
        callback(feedbackData, error)
        if (error) {
          console.log('subscribeFeedbackData error:', error)
        } else {
          setFeedbackDataList(feedbackData)
        }
      }
    )
    unsubscribeFeedbackDataListRef.current = unsubscribe
  }

  async function subscribeFeedbackCounter() {
    if (unsubscribeFeedbackCounterDataRef.current === null) {
      const name = COLLECTION_NAME.FEEDBACK

      const unsubscribe = await subscribeCounterData(name, async (counterData, error) => {
        if (error) {
          console.log('subscribeFeedbackounter error:', error)
        } else if (!isEmpty(counterData)) {
          setFeedbackCounterData(counterData)
        }
      })
      unsubscribeFeedbackCounterDataRef.current = unsubscribe
    }
  }

  // Action
  async function createNewFeedback(feedbackId, newData) {
    //
    const resultUpdated = await addData(COLLECTION_NAME.FEEDBACK, feedbackId, newData)

    return resultUpdated
  }

  async function updateFeedbackInfo(feedbackId, newData) {
    //
    const resultUpdated = await addData(COLLECTION_NAME.FEEDBACK, feedbackId, newData)

    return resultUpdated
  }

  function clearAllSubscribe() {
    if (unsubscribeFeedbackDataListRef.current) {
      unsubscribeFeedbackDataListRef.current && unsubscribeFeedbackDataListRef.current()
    }
    if (unsubscribeFeedbackCounterDataRef.current) {
      unsubscribeFeedbackCounterDataRef.current && unsubscribeFeedbackCounterDataRef.current()
    }
  }

  return {
    feedbackDataList,
    feedbackCounterData,
    actions: {
      getCurrentData,
      subscribeFeedbackCounter,
      createNewFeedback,
      updateFeedbackInfo,
      clearAllSubscribe
    }
  }
}
